var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneEmpty = function SvgPhoneEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.64 14.407-2.356 2.32a19.11 19.11 0 0 1-3.4-2.612 19.353 19.353 0 0 1-2.612-3.4l2.32-2.355a1.01 1.01 0 0 0 .207-1.1L7.382 1.614A1.009 1.009 0 0 0 6.2 1.036L1.756 2.209A1.007 1.007 0 0 0 1 3.218a21.337 21.337 0 0 0 6.04 13.74A21.339 21.339 0 0 0 20.783 23a1.011 1.011 0 0 0 1.01-.756l1.172-4.44a1.01 1.01 0 0 0-.577-1.186L16.75 14.2a1.01 1.01 0 0 0-1.11.207z",
    stroke: "#fff",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPhoneEmpty;